import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';
import { CDFTService } from 'app/modules/cdft/services/cdft.service';
import { toFormData } from 'app/core/shared/helper/url.helper';
import modules from "app/modules/cdft/cdft.module";

@Component({
    selector: 'app-status-modal',
    templateUrl: './status-modal.component.html',
    styleUrls: ['./status-modal.component.scss'],
    standalone: true,
    imports: modules,
})
export class StatusModalComponent {
    form: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<StatusModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private state: CDFTState,
        private service: CDFTService,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        this.setForm();
    }

    setForm() {
        this.form = this.formBuilder.group({
            id: new FormControl({ value: this.state.id, disabled: false }),
            status: new FormControl({
                value: this.state.status,
                disabled: false,
            }),
            remarks: new FormControl({
                value: this.state.remarks,
                disabled: false,
            }),
        });
    }

    update() {
        const form = this.form.getRawValue();
        
        const payload: any = {
            cdftRecordId : form.id,
            cdftStatus : form.status,
            remark : form.remarks,
        }

        this.service.approvedCdftRecord(payload).subscribe(() => {
            this.state.status = this.form.getRawValue().status;
            this.state.remarks = this.form.getRawValue().remarks;
            this.dialogRef.close({status : this.state.status});
        });
    }
}
